<template>
  <div class="alert alert-info alert-soft mb-3" ...attributes>
    {{yield}}
  </div>
</template>
